import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdownNumber", "countdownPill", "progressBar"]
  static values = { returnUrl: { type: String, default: "/kiosk" }, delay: { type: Number, default: 3000 } }

  connect() {
    this.remaining = Math.ceil(this.delayValue / 1000)
    this.tickInterval = setInterval(() => this.tick(), 1000)
    this.tick()
    this.timeout = setTimeout(() => {
      clearInterval(this.tickInterval)
      window.location.href = this.returnUrlValue
    }, this.delayValue)
  }

  tick() {
    if (this.hasCountdownNumberTarget) {
      this.countdownNumberTarget.textContent = Math.max(0, this.remaining)
    }
    this.remaining -= 1
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    if (this.tickInterval) clearInterval(this.tickInterval)
  }
}
